import ptLocale from 'element-ui/lib/locale/lang/pt'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "Análise do Relatório IA",
        train: "Plano Formativo",
        loading: "A carregar...",
        loadingError1: "Erro ao carregar",
        loadingError2: "Desculpe. Tente mais tarde.",
    },
    login: {
        userLogin: 'Acesso',
        title: 'A conta configurada por e-mail e número de telefone são independentes uma da outra, por favor.',
        mobileLogin: 'Telefone',
        emailLogin: 'Email',
        email: 'E-mail',
        loginBtn: 'Entrar',
        autoLogin: 'Lembrar-me',
        retransmission: '{item}s',
        formList: [
            {
                label: 'Insira seu número de telefone',
                placeholder: 'Enviar',
            },
            {
                label: 'Código de verificação',
                placeholder: 'Insira o código de verificação',
            },
            {
                label: 'Por favor, insira seu e-mail',
            },
        ],
        btn: {
            submit: 'Criar conta',
            title: 'Para obter dados precisos, é importante inserir a altura, gênero e idade corretos',
        },
        rule: {
            phone: {
                requiredMsg: 'Formato de número de telefone inválido',
                patternMsg: 'Telefone não registrado, crie sua conta',
            },
            authCode: {
                requiredMsg: 'Código de verificação incorreto, por favor digite novamente',
            },
            email: {
                requiredMsg: 'Formato de e-mail incorreto',
                patternMsg: 'E-mail não registrado, crie sua conta',
            },
        },
        success: 'Envio realizado com sucesso',
        error: 'Falha no envio',
        loginSuccess: 'Login realizado com sucesso',
        loginAndRegister: 'Cadastre-se / Entrar',
        codeSuccess: 'O código de verificação foi enviado, por favor, verifique.',
        registerAndLogin: 'Entrar',
        account: {
            accountTitle: 'Entrar',
            registerTitle: 'Entrar',
            resetTitle: 'Configurar senha',
            password: 'Senha',
            placeholder: 'Por favor, insira a senha',
            codeLogin: 'Entrar com código de verificação',
            accountLogin: 'Entrar com senha',
            forgotPassword: 'Esqueceu a senha?',
            registerTips:[
                'Ainda não tem conta?', 
                'Entrar', 
                'A conta já existe',
                'Registe-se',
            ],
            checkRule: [
                'De 8 a 20 caracteres',
                'Deve incluir pelo menos uma letra maiúscula',
                'Deve incluir pelo menos uma letra minúscula',
                'Deve incluir pelo menos um número', 
                'As senhas não coincidem'
            ],
            errorTips: [
                'Senha incorreta', 
                'Falha no login', 
                'A conta não existe'
            ],
            reset:[
                'Redefinir senha', 
                "Próximo",
                'A nova senha não pode ser igual à anterior', 
                'Pular',
                'Senha configurada com sucesso'
            ],
            setPasswordTips:'A senha deve ter entre 8 e 20 caracteres e incluir letras maiúsculas, letras minúsculas e números.',
            confirmPassword: "Confirmar contraseña",
        },
        switchButton: 'Login com senha',
        switchButton1: 'Entrar com código de verificação',
        loginTips: 'Contas não cadastradas serão automaticamente cadastradas após o login bem-sucedido.',
        otherLogin: 'Outros métodos de login',
        newEmailLogin: 'Login com e-mail',
        newPhoneLogin: 'Login com número de celular',
        bindLineTips:'Ou',
        bindEmail: 'Login com e-mail vinculado',
        bindPhone: 'Login com número de celular vinculado',
        bindAndContinue: "Vincular e continuar",
        bind: "Vincular",
        bindEmailTitle: 'Vincular e-mail',
        bindEmailTips1: "E-mail do {item} não encontrado",
        bindEmailTips2: "Vincule um e-mail para continuar",
        bindEmailTips3: "Sua conta não tem e-mail vinculado. Com ele, você poderá fazer login e recuperar sua senha.",
        boundTitle: 'Já tem uma conta?',
        boundCenterTitle1:'Se você é um novo usuário',
        boundCenterTips1:'Crie uma conta para começar a usar',
        boundCenterTitle2:'Se você já possui uma conta',
        boundCenterTips2:'Vincule sua conta para sincronizar dados históricos',
        boundCenterTips3:'Por favor, vincule uma conta registada',
        boundCenterTips4:'Recomendado',
        boundCenterTips5:'Vincular conta {item} a uma conta existente',
        boundCenterTips6:'Após vincular, os dados e relatórios serão sincronizados automaticamente',
        boundButton1: 'Criar conta com {item}',
        boundButton2: 'Vincular conta existente',
        phoneCode:"Login via código SMS",
        phonePassword:"Celular e senha",
        emailCode:"Login via código de e-mail",
        emailPassword:"E-mail e senha",
        accountDoesNotExist:"Esta conta ainda não está registrada. Conclua o registro usando um código de verificação por e-mail ou via {item}.",
        toRegister:"Cadastrar-se",
        bindNow: "Vincular agora",
        bindError:[
            'Falha na vinculação',
            'Desvinculação bem-sucedida',
            'Falha ao Desvincular',
            'Falha na Autorização',
            'Falha na Autorização, Não Foi Possível Obter as Informações da Conta',
            'Conta Vinculada com Sucesso',
            'A conta não existe. Por favor, associe uma conta registada.',
            'Falha na associação. Esta conta já está associada à conta {item} [{nickname}].',
            'Autorizado e registado como uma conta, não é possível desvincular',
            'A conta não existe, por favor, use o código de verificação para iniciar sessão e registar',
        ],
        accountSecurity: {
            faceBook:'Conta do Facebook',
            google: 'Conta do Google',
            isBind: 'Não vinculado',
            dialogTitle: 'Confirmar desvinculação?',
            dialogCenter: 'Após desvincular {item}, você não poderá mais usá-lo para fazer login nesta conta.',
            bindFailure:'Falha na vinculação',
            bindFailureTips: 'Sua conta {item} já está vinculada à conta abaixo. Se você deseja transferir a vinculação para a conta atual, faça login na conta abaixo para desvinculá-la primeiro.',
            returnButton:'Confirmar e voltar'
        },
        bindEmailError: [
            "Este e-mail já existe. Tente outro."
        ],
    },
    register: {
        mobileRegister: 'Telefone',
        emailRegister: 'Email',
        enroll: 'Número de celular já registrado',
        search: 'Pesquisar',
        title: 'A conta configurada por e-mail e número de telefone são independentes uma da outra, por favor.',
        needRead: {
            agree: 'Eu concordo',
            privacy: '(Política de Privacidade)',
        },
        register: 'Entrar',
        check: "Verificar 'Privacidade do Usuário'",
        newUser: 'Entrar',
        form: {
            labelList: ['Nome', '* Gênero', '* Altura', '* Idade'],
        },
        placeholder: ['Por favor insira seu nome', 'Por favor insira sua altura', 'Por favor insira sua idade'],
        unit: ['Medição', 'Imperial', ''],
        sexOptions: {
            male: 'Masculino',
            female: 'Feminino',
        },
        btn: 'Enviar',
        rules: {
            metricheight: ["A faixa de altura é de 2'3'' a 6'7''. Por favor, insira novamente"],
            heightMsg: ['A faixa de altura é de 70 a 200cm. Por favor, insira novamente'],
            ageMsg: ['A faixa etária é de 10 a 99 anos, por favor, insira novamente'],
            agePointMsg: [
                'Preenchimento fracionado: a idade só pode ser um número inteiro, por favor, preencha a idade corretamente',
            ],
        },
        success: 'Registro realizado com sucesso',
        userMessage: 'Insira o nome do usuário',
        verify: 'Insira o código de verificação de 4 dígitos',
        errorMsg: 'Formato de altura não suporta decimais. Por favor, insira novamente',
        enrollEmail: 'Email registrado',
        abnormalMsg: 'Anomalia de registro',
    },
    model: {
        loading: 'Carregando... Por favor, aguarde um momento',
        modelLoading: 'Carregando Modelo 3D',
        tabPane: [
            {
                title: 'Tecnologia Deep Real Sense',
                msg: 'Colete com precisão detalhes locais do corpo através do escaneamento 3D, garanta a precisão de milímetros na medição da circunferência e apresente claramente as mudanças do formato do corpo após o treino',
            },
            {
                title: 'Algoritmo de composição corporal BDA',
                msg: 'O Visbody usa o sistema de medição de composição corporal mais avançado (algoritmo BDA) para determinar a composição corporal. Este método de cálculo, baseado no volume corporal, avaliará com mais precisão os riscos à saúde trazidos pela obesidade.',
            },
            {
                title: 'Fatores que causaram erros',
                msg: 'Roupas largas ou algumas decorações no corpo causarão erros, por favor, use roupas justas ou reduza a quantidade de roupas no seu corpo, se quiser obter dados mais precisos.',
            },
            {
                title: 'Obtenha seu relatório',
                msg: 'Recomenda-se salvar a URL da página da web para facilitar a visualização do relatório no futuro. Você também pode enviar este relatório para sua caixa de correio para salvá-lo mais tarde',
            },
        ],
        collect: [
            'Por favor, salve esta página, Fácil de revisar o relatório no futuro. Fácil de revisar o relatório no futuro.',
            '',
        ],
        know: 'Eu entendi',
        reminder: [
            'Lembrar-me',
            'Seu modelo de avatar 3D foi gerado, deslize para a esquerda e para a direita para girá-lo',
            "Seu relatório foi gerado e pode ser visualizado clicando no botão 'Ver Relatório'",
            'Sua avaliação corporal não foi bem sucedida. Por favor, revise o relatório de composição corporal.',
            'Sua composição corporal não foi bem sucedida. Por favor, revise o relatório de avaliação postural.',
            'Sua medição não foi bem sucedida. Por favor, volte ao dispositivo e tente novamente.',
            'A medição da composição corporal não foi bem sucedida. Por favor, volte ao dispositivo e tente novamente.',
            'A avaliação postural não foi bem sucedida. Por favor, volte ao dispositivo e tente novamente.',
        ],
        btn: {
            viewReport: 'Ver relatório',
            bodyReport: 'Ver relatório de composição corporal',
            postureReport: 'Ver relatório de postura corporal',
            lastReport: 'Ver último relatório',
            loading: 'Carregando',
        },
    },
    report: {
        btn: {
            download: 'Baixar o relatório',
            send: 'Enviar relatório',
            report: 'Relatório',
        },
        reportSuccess: 'Sucesso!',
        tabPane: {
            labelList: ['Tempo de medição', 'Item', 'Composição corporal', 'Avaliação de postura', 'Função do ombro'],
        },
        sendEmail: 'Email:',
        requiredMsg: 'Digite seu endereço de e-mail',
        patternMsg: 'Por favor, insira um endereço de e-mail válido',
        send: 'Enviar',
        download: 'Baixar relatório',
        sendReport: 'Enviar relatório',
    },
    sidebar: {
        successMsg: {
            sex: 'Gênero alterado com sucesso',
            height: 'Altura alterada com sucesso',
            age: 'Idade alterada com sucesso',
        },
        logOut: 'Sair',
        personal: 'Centro Pessoal',
        cut: 'Alterar Unidades/Idiomas',
        unit: ['Métricas (kg, cm)', 'Imperial (ft, in, lb)'],
        read: {
            reading: 'Leia',
            privacy: '(Política de Privacidade)',
        },
        setting: 'Configurações',
        form: {
            labelList: ['Telefone', 'Unidades', 'Idiomas', 'Nome', 'Gênero', 'Altura', 'Idade'],
        },
        placeholder: ['Altere seu nome de usuário', 'Novo gênero', 'Altura atualizada', 'Idade atualizada'],
        btn: {
            cancelBtn: 'Cancelar',
            accomplishBtn: 'Completar',
            confirmBtn: 'Confirmar',
        },
        dialog: [
            'O gênero é uma das bases importantes para a medição da composição corporal. Os dados medidos após a modificação serão diferentes dos dados anteriores. Por favor, confirme se você quer mudar isso.',
            'A altura é uma das bases importantes para a medição da composição corporal. Os dados medidos após a modificação serão diferentes dos dados anteriores. Por favor, confirme se você quer mudar isso.',
            'A idade é uma das bases importantes para a medição da composição corporal. Os dados medidos após a modificação serão diferentes dos dados anteriores. Por favor, confirme se você quer mudar isso.',
        ],
        rules: {
            metricheight: ["Por favor, preencha a faixa de altura correta (2' 3'' a 6'7'')"],
            heightMsg: ['Por favor, preencha a altura dentro de 70cm a 200cm'],
            ageMsg: [
                'Por favor, preencha a idade dentro de 10 a 99 anos',
                'Preenchimento fracionado, a idade só pode ser um número inteiro. Por favor, preencha a idade correta.',
            ],
        },
        heightMsg: 'Por favor, preencha novamente a altura',
        ageMsg: 'Por favor, preencha novamente a idade',
        ModelBinding: 'Parece que alguém já escaneou o código. Por favor, meça novamente!',
        ReportEmpty: {
            title: 'Você ainda não tem nenhum relatório',
            desc: 'Vá para o scanner corporal 3D Visbody e teste novamente!',
        },
        changeSort: 'Troca de relatório do produto',
        setPassword: 'Configurar/Alterar senha',
        accountSecurity: 'Conta e segurança',
        describe: 'Após a troca do modelo do produto, todos os relatórios de medição sob este modelo serão exibidos.',
        describeBtn:
            'Após a troca do modelo do produto, você será redirecionado para o relatório de medição mais recente sob este modelo.',
        descReport: 'Troca de relatório do produto realizada com sucesso',
    },
    modelBinding: {
        desc: 'Parece que alguém já escaneou o código. Por favor, meça novamente!',
    },
    reportEmpty: {
        title: 'Você ainda não tem nenhum relatório',
        desc: 'Vá para o scanner corporal 3D Visbody e teste novamente!',
        descS30: 'Vá para o scanner corporal 3D Visbody e teste novamente!',
        descM30: 'Vá para o scanner corporal 3D Visbody e teste novamente!',
    },
    userInfo: {
        height: 'Altura:',
        age: 'Idade:',
        unit: '',
        weight: 'Peso',
    },
    null: 'null',
    mass: {
        title: 'Visão geral da avaliação de composição corporal',
        titles: 'Composição corporal',
        springFrame: 'Sem dados de medição para o dia',
        contrast: 'Escolha um relatório para comparar',
        contrastReport: 'Escolha um relatório para comparar',
        noRecord: 'Sem registros',
        score: 'Pontuação',
        status: 'Seu atual estado de composição corporal',
        WT: 'Peso',
        PBF: 'Percentual de gordura corporal',
        measure: {
            value: 'Valores',
            standardRange: 'Faixa padrão',
            comparedWithLastLime: 'Líquido',
            comparedNet: 'Comparado com a última pontuação',
            WT: 'Peso',
            FFM: 'Massa Livre de Gordura',
            BFM: 'Massa Gordura',
            LM: 'Massa Muscular',
            TBW: 'Água Total',
            SM: 'SMM (Massa Muscular Esquelética)',
            PROTEIN: 'Proteína',
            TM: 'Minerais',
            BMR: 'Basal Metabolic Rate',
            WHR: 'Relação Cintura-Quadril',
            BMI: 'IMC',
            PBF: 'PGC (Percentual de Gordura Corporal)',
            VFG: 'Nível de Gordura Visceral',
            unit: 'Kg',
            BMRUnit: 'Kcal/d',
            current: 'Pontuação desta medição',
        },
        explain: [
            {
                title: 'Peso',
                msg: 'O peso é a soma da água corporal, proteína, sal inorgânico e peso corporal.',
            },
            {
                title: 'Massa Livre de Gordura',
                msg: 'A massa corporal magra é o peso corporal total sem gordura.',
            },
            {
                title: 'Massa Gordura',
                msg: 'A massa de gordura corporal é a soma da gordura subcutânea, gordura visceral e gordura muscular.',
            },
            {
                title: 'Massa Muscular',
                msg: 'A massa magra suave é a massa corporal magra, que inclui músculo esquelético, músculo liso e músculo cardíaco.',
            },
            {
                title: 'Água Total',
                msg: 'A maior parte do corpo humano é composta por água, com uma quantidade de 50% a 70% do peso corporal. E a água corporal está principalmente nas células humanas e nos fluidos corporais, a maior parte dos quais está nas células musculares.',
            },
            {
                title: 'MME',
                msg: 'A massa muscular esquelética, também conhecida como músculo estriado, é um tipo de músculo ligado aos ossos. Esses dados contêm a quantidade de Músculo Esquelético.',
            },
            {
                title: 'Proteína',
                msg: 'A proteína é uma substância sólida com amônia, que existe em todas as células do corpo humano. É o principal componente da massa muscular.',
            },
            {
                title: 'Minerais',
                msg: 'O corpo humano é composto por matéria orgânica, matéria inorgânica e água. A matéria inorgânica aqui são sais inorgânicos, que correspondem a 5% do peso corporal.',
            },
            {
                title: 'Basal Metabolic Rate',
                msg: 'A taxa de metabolismo basal é a energia total consumida em um dia quando o corpo está em repouso, não afetada por exercícios, objetos físicos, nervosismo, mudanças de temperatura externa, etc.',
            },
            {
                title: 'Relação Cintura-Quadril',
                msg: 'A relação da circunferência da cintura com o quadril é um indicador importante para determinar a obesidade central.',
            },
            {
                title: 'IMC',
                msg: 'O IMC é usado, principalmente, para avaliar o grau da obesidade e é um padrão comum para medir a gordura corporal.',
            },
            {
                title: 'PGC',
                msg: 'PGC é uma medida da composição corporal que indica quanto do peso corporal é gordura.',
            },
            {
                title: 'Nível de Gordura Visceral',
                msg: 'A gordura visceral é um indicador importante para avaliar a obesidade oculta.',
            },
            {
                title: 'Água Intracelular',
                msg: 'Água Intracelular: é o fluido corporal intracelular e é o componente básico do protoplasma.',
            },
            {
                title: 'Água extra-celular',
                msg: 'Água extra-celular: normalmente refere-se aos fluidos corporais extracelulares, incluindo plasma e fluido intersticial entre vasos sanguíneos e células teciduais.',
            },
            {
                title: 'Idade Metabólica',
                msg: 'A idade metabólica refere-se ao desempenho do corpo e suas funções de saúde relacionadas ao metabolismo.',
            },
            {
                title: 'Rapporto ECW/TBW',
                msg: 'Il rapporto ECW/TBW è la proporzione di acqua extracellulare (ECW) rispetto all’acqua corporea totale (TBW). È un indicatore importante per valutare l’equilibrio dei fluidi corporei.',
            },
        ],
        segment: {
            fat: 'Análise segmentar de gordura',
            muscle: 'Análise segmentar da massa magra',
            right: 'Direito',
            left: 'Esquerdo',
            standard: 'Normal',
            lowStandard: 'Baixo',
            superStandard: 'Alto',
            peel: '(Tare)',
        },
        massFrame: 'Sem dados de medição para o dia',
        endSymbol: '.',
    },
    shape: {
        title: 'Visão geral da avaliação corporal',
        titles: 'Postura',
        status: 'Sua condição física atual',
        suggest: 'Sugestão',
        possibility: ', existe a possibilidade de',
        models: {
            front: 'Frente',
            left: 'Lado esquerdo',
            right: 'Lado direito',
            top: 'Atrás',
            low: 'Baixo',
            high: 'Alto',
            normal: 'Normal',
        },
        item: {
            deviate: 'Valor da medição',
            result: 'Explicação',
            normal: 'Normal',
			keAbnormal: 'Suspeita de anomalia',
            abnormal: 'Anormal',
            head: 'Postura de cabeça para frente',
            headSlant: 'Inclinação da cabeça',
            roundShoulderLeft: 'Postura protusa/curvada de ombros (lado esquerdo)',
            roundShoulderRight: 'Postura protusa/curvada de ombros (lado direito)',
            highLowShoudler: 'Ombros desiguais',
            leftKneeCheck: 'Avaliação do joelho esquerdo',
            rightKneeCheck: 'Avaliação do joelho direito',
            leg: 'Forma da perna',
            leftLeg: 'Perna esquerda',
            rightLeg: 'Perna direita',
            pelvis: 'Deslocamento pélvico para frente/Deslocamento pélvico posterior',
        },
        explain: [
            {
                title: 'Postura de cabeça para a frente',
                msg: 'O ângulo entre o ponto da orelha do lado esquerdo, a linha que conecta o centro do pescoço e a linha mediana do lado',
            },
            {
                title: 'Inclinação da cabeça',
                msg: 'O ângulo entre o ponto médio da frente da cabeça, o centro do pescoço e a linha média da frente',
            },
            {
                title: 'Postura de ombros curvados (lado esquerdo)',
                msg: 'O ângulo entre a linha que conecta o ponto mais alto do lado esquerdo das costas e a linha tangente do ombro',
            },
            {
                title: 'Postura de ombros curvados (lado direito)',
                msg: 'O ângulo entre a linha que conecta o ponto mais alto do lado direito das costas e a tangente ao ombro',
            },
            {
                title: 'Ombros desiguais',
                msg: 'A distância vertical entre os pontos do ombro esquerdo e direito nas costas',
            },
            {
                title: 'Deslocamento pélvico para frente/deslocamento pélvico posterior',
                msg: 'O ângulo incluído da linha que conecta o ponto central do pescoço, o ponto do osso do quadril e o ponto do tornozelo do lado esquerdo',
            },
            {
                title: 'Avaliação do joelho esquerdo',
                msg: 'O ângulo incluído da linha de três pontos que conecta o ponto do osso do quadril, a articulação do joelho e o ponto do tornozelo do lado esquerdo',
            },
            {
                title: 'Avaliação do joelho direito',
                msg: 'O ângulo incluído da linha de três pontos que conecta o ponto do osso do quadril, a articulação do joelho e o ponto do tornozelo do lado direito',
            },
            {
                title: 'Forma da perna',
                msg: 'O ângulo incluído da linha que conecta o ponto do osso do quadril, a articulação do joelho e o ponto do tornozelo na frente das pernas esquerda e direita',
            },
            {
                title: 'Inclinação Pélvica Anterior/Posterior',
                msg: 'O ângulo entre a vertical e o plano formado pelas Espinhas Ilíacas Anterossuperiores esquerda e direita e a Sínfise Púbica.'
            },
            {
                title: 'Dismetria dos Membros Inferiores',
                msg: 'A diferença de altura a partir do chão entre os pontos mais baixos das pregas glúteas esquerda e direita.'
            }
        ],
        exception: [
            {
                title: 'Inclinado para o lado esquerdo',
                abnormal: 'Inclinado para o lado esquerdo',
            },
            {
                title: 'Inclinado para o lado direito',
                abnormal: 'Inclinado para o lado direito',
            },
            {
                title: 'Esquerda alta',
                abnormal: 'Esquerda alta',
            },
            {
                title: 'Direita alta',
                abnormal: 'Direita alta',
            },
            {
                title: 'Inclinação pélvica posterior',
                abnormal: 'Inclinação pélvica posterior',
            },
            {
                title: 'Inclinação pélvica anterior',
                abnormal: 'Inclinação pélvica anterior',
            },
            {
                title: 'Hiperextensão do joelho esquerdo',
                abnormal: 'Hiperextensão do joelho esquerdo',
            },
            {
                title: 'Flexão anterior do joelho esquerdo',
                abnormal: 'Flexão anterior do joelho esquerdo',
            },
            {
                title: 'Hiperextensão do joelho direito',
                abnormal: 'Hiperextensão do joelho direito',
            },
            {
                title: 'Flexão anterior do joelho direito',
                abnormal: 'Flexão anterior do joelho direito',
            },
            {
                title: 'Pernas em forma de K',
                abnormal: 'Pernas em forma de K',
            },
            {
                title: 'Pernas em forma de D',
                abnormal: 'Pernas em forma de D',
            },
            {
                title: 'Pernas em forma de X',
                abnormal: 'Pernas em forma de X',
            },
            {
                title: 'Pernas em forma de O',
                abnormal: 'Pernas em forma de O',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Distância vertical entre as orelhas e a linha de gravidade corporal',
            },
            {
                msg: 'Ângulo entre a linha que une ambas as orelhas e o plano horizontal',
            },
            {
                msg: 'Distância vertical entre o acrómio esquerdo e a linha de gravidade',
            },
            {
                msg: 'Distância vertical entre o acrómio direito e a linha de gravidade',
            },
            {
                msg: 'Diferença nas linhas que unem a base do pescoço aos acrómios em ambos os lados',
            },
            {
                msg: 'Distância vertical entre a articulação coxofemoral e a linha de gravidade corporal',
            },
            {
                msg: 'Ângulo formado pelo tornozelo, um ponto 1 cm abaixo da articulação do joelho esquerdo e a articulação coxofemoral no plano sagital',
            },
            {
                msg: 'Ângulo formado pelo tornozelo, um ponto 1 cm abaixo da articulação do joelho direito e a articulação coxofemoral no plano sagital',
            },
            {
                msg: 'Ângulo entre as articulações coxofemorais, dos joelhos e dos tornozelos bilaterais no plano coronal',
            },
          ],
        item: {
            pelvis: 'Anteversão pélvica',
        },
    },
    girth: {
        title: 'Circunferências',
        present: '(Presente)',
        tpl: [
            {
                title: 'Circunferência do pescoço',
                key: 'neckGirth',
            },
            {
                title: 'Braço superior esquerdo',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Braço superior direito',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Peito',
                key: 'bustGirth',
            },
            {
                title: 'Cintura alta',
                key: 'waistGirth',
            },
            {
                title: 'Cintura média',
                key: 'midWaistGirth',
            },
            {
                title: 'Quadril',
                key: 'hipGirth',
            },
            {
                title: 'Coxa esquerda',
                key: 'leftThighGirth',
            },
            {
                title: 'Meio da coxa esquerda',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Circunferência mínima da coxa esquerda',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Circunferência da coxa direita',
                key: 'rightThighGirth',
            },
            {
                title: 'Meio da coxa direita',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Circunferência mínima da coxa direita',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Circunferência da panturrilha esquerda',
                key: 'leftCalfGirth',
            },
            {
                title: 'Circunferência da panturrilha direita',
                key: 'rightCalfGirth',
            },
            {
                title: 'Cintura baixa',
                key: 'lowWaistGirth',
            },
        ],
        noHistory: 'Sem dados',
    },
    shoulder: {
        title: 'Função do ombro',
        model: {
            val: 'Valor',
            scope: 'Local de Atividade Máxima',
            diff: 'Líquido',
        },
        normal: 'Bom',
        conclusion: 'Conclusão',
        analyse: 'Análise:',
        suggest: 'Sugestão:',
        cause: 'Por favor, peça informações aos especialistas para mais detalhes.',
        normalAll: 'A função do ombro não apresenta anomalias evidentes no momento.',
    },
    saveQr: {
        title: 'Relatório de escaneamento corporal 3D Visbody',
        btnMsg: 'Mantenha pressionada a imagem para salvá-la em seu telefone.',
        tips: 'Se você não conseguir salvar, por favor, vá para [Configurações] e abra as permissões correspondentes.',
    },
    reportTips: {
        title: "Tem a certeza de que pretende eliminar este relatório? Depois de eliminado, não poderá ser recuperado.",
        confirm: "Eliminar",
        success: "Relatório eliminado",
        partial: "O relatório foi eliminado, mas a sincronização de alguns dados falhou. Contacte o administrador.",
        failed: "Não foi possível eliminar. Tente novamente mais tarde.",
        btnMsg: 'OK',
        alaryTips: 'Este relatório foi deletado pelo administrador. Irá pular para o próximo relatório!',
    },
    share: {
        title: 'Por favor, copie o link abaixo e compartilhe.',
        btnMsg: 'Copiar',
    },
    "waist": {
    "title": "Perímetro da Cintura e Abdômen",
    "hou": "Post.",
    "qian": "Ant."
  },
  "yao_wei_1": "Cintura",
  "yao_bu_fen_shu": "Pontuação da Cintura",
  "waist_fen": "Pontuação",
  "yao_wei": "Perímetro da Cintura",
  "yao_wei_jian_ti_ji": "Volume entre cinturas",
  "yao_tun_bi": "Relação Cintura-Quadril",
  "lun_kuo_fen_xi": "Análise de Contorno",
  "bei_bu": "Região Dorsal",
  "tunbu": "Região Glútea",
  "bei_bu_ti_ji": "Volume Dorsal",
  "zheng_chang_fan_wei": "Faixa Normal:",
  "shang_ci": "Ant. ",
  "ben_ci": "Atual ",
  "gupen": {
    "zheng_chang": "Normal",
    "qian_qin_yan_chang": "Anteversão Anormal",
    "qian_qin_yi": "Risco de Anteversão",
    "hou_qin_yi": "Risco de Retroversão",
    "hou_qin_yan_chang": "Retroversão Anormal",
    "zuo_chang_yan_chang": "Comprimento Anormal da Perna Esquerda",
    "zuo_chang_yi": "Risco de Assimetria (Esquerda Maior)",
    "you_chang_yi": "Risco de Assimetria (Direita Maior)",
    "you_chang_yan_chang": "Comprimento Anormal da Perna Direita"
  },
  "gao_yao_xian": "Cintura Alta",
  "gao_yao_zhong_xian": "Linha Média da Cintura Alta",
  "gao_yao_xia_xian": "Linha Inferior de Cintura Alta",
  "xiao_yao_shang_xian": "Linha Superior de Cintura Baixa",
  "xiao_yao_zhong_xian": "Linha Média da Cintura Baixa",
  "xiao_yao_xian": "Cintura Baixa",
  "qv_jian1": "Secção Superior de Cintura Alta",
  "qv_jian2": "Secção Inferior de Cintura Alta",
  "qv_jian_zhong": "Secção de Cintura Média",
  "qv_jian3": "Secção Superior de Cintura Baixa",
  "qv_jian4": "Secção Inferior de Cintura Baixa",
  "celiang.failed": "Medição sem êxito, use roupa justa e permaneça imóvel durante a medição",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Cabeça projetada/inclinada com leve desvio cervical. Atenção à postura sentada.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Cabeça projetada/inclinada com desvio cervical. Recomenda-se controle postural e treino.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Forte inclinação da cabeça e desvio cervical. Avaliação profissional recomendada.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Leve desvio torácico. Melhore o controle postural.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Desvio torácico afeta a estabilidade. Recomendados exercícios específicos.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Desvio torácico evidente e assimetria. Correção profissional recomendada.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Leve desvio lombar, postura equilibrada. Recomendado treino de core.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Desvio lombar afeta a estabilidade. Recomendados exercícios corretivos.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Desvio lombar evidente. Plano de melhoria profissional recomendado.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Hipertonia: elevador da escápula, ECOM e trapézio superior. Fraqueza: flexores profundos do pescoço. Recomendado estabilização e relaxamento.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertonia: ECOM esquerdo e escaleno posterior. Fraqueza: ECOM direito. Recomendado equilíbrio bilateral e relaxamento cervical.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertonia: ECOM direito. Fraqueza: ECOM esquerdo e escaleno posterior. Recomendado estabilização simétrica e relaxamento cervical.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertonia: trapézio superior esquerdo. Fraqueza: trapézio médio/inferior. Recomendado treino (médio/inferior) e relaxamento.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Hipertonia: rotadores internos e adutores. Fraqueza: glúteo médio. Recomendado treino do glúteo médio e alongamento.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Hipertonia: glúteo médio e piriforme. Fraqueza: adutores, rotadores internos e LCL. Recomendado estabilização das pernas e relaxamento dos glúteos.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Hipertonia: glúteo médio e piriforme. Fraqueza unilateral: adutores, rotadores internos e LCL. Recomendado treino bilateral.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertonia: isquiotibiais esquerdos e poplíteo. Fraqueza: quadríceps e sóleo. Recomendado treino de quadríceps/sóleo e alongamento.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertonia: quadríceps esquerdo. Fraqueza: glúteo máximo e isquiotibiais. Recomendado treino de glúteos/cadeia posterior e alongamento.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertonia: isquiotibiais direitos e poplíteo. Fraqueza: quadríceps e sóleo. Recomendado treino de quadríceps/sóleo e alongamento.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertonia: quadríceps direito. Fraqueza: glúteo máximo e isquiotibiais. Recomendado treino de glúteos/cadeia posterior e alongamento.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Leve desvio espinhal. Atenção à postura e treine o core.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Desvio espinhal moderado. Treino profissional recomendado.",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertonia: trapézio superior direito. Fraqueza: trapézio médio/inferior. Recomendado treino (médio/inferior) e relaxamento.",
    ...ptLocale,
    ...agrEn,
  "neckReport": {
  "title": "Função cervical",
  "conclusion": "Avaliação da função cervical",
  "loading": "O relatório está a ser gerado. Aguarde.",
  "failed": "Falha na síntese",
  "analysis": "Análise",
  "suggestion": "Sugestão",
  "suggestionText": "Procure um profissional para investigação e tratamento específico."
}
}
